import { onMounted, onUnmounted, Ref } from 'vue'

declare global {
  interface Window {
    birdieSettings: {
      app_id: string
      contact_name: string
      contact_email: string
      contact_id: string
    }
  }
}

interface BirdieSettings {
  contactName: string
  contactEmail: string
  contactId: string
}

interface FormData {
  description: string
}

export function useBirdieIntegration(
  formData: Ref<FormData>,
  { contactName, contactEmail, contactId }: BirdieSettings
): { recordVideo: () => void } {  
  const handleBirdieMessage = (event: MessageEvent) => {
    if (
      event.origin.includes('birdie.so') &&
      event.data?.type === 'birdie_widget::recording_complete'
    ) {
      const videoUrl = event.data.payload?.recording?.url
      if (videoUrl) {
        const currentText = formData.value.description?.trim() || ''
        formData.value.description = `${currentText}\n\n🎥 Video recording:\n${videoUrl}`
      }
    }
  }

  const recordVideo = () => {
    console.log('recordVideo triggered')
    
  }

  onMounted(() => {
    window.birdieSettings = {
      app_id: 'r05tgo6u',
      contact_name: contactName || 'Anonymous',
      contact_email: contactEmail || '',
      contact_id: contactId || ''
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = `https://app.birdie.so/widget/${window.birdieSettings.app_id}`
    document.body.appendChild(script)

    window.addEventListener('message', handleBirdieMessage)
  })

  onUnmounted(() => {
    window.removeEventListener('message', handleBirdieMessage)
  })

  return {
    recordVideo  
  }
}